import { cn } from '@/lib/utils'

export function Card({ as: Tag = 'div', className, children, hoverable = false, ...props }) {
  return (
    <Tag
      className={cn(
        'rounded-2xl bg-white shadow-soft ring-1 ring-ink-100',
        hoverable && 'transition-all duration-200 hover:shadow-card hover:-translate-y-0.5',
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  )
}

export function CardHeader({ className, title, description, action, eyebrow }) {
  return (
    <div className={cn('flex items-start justify-between gap-4 px-6 pt-6', className)}>
      <div>
        {eyebrow && <p className="label-text mb-1">{eyebrow}</p>}
        {title && (
          <h3 className="h-display text-lg font-semibold text-ink-900">{title}</h3>
        )}
        {description && (
          <p className="mt-1 text-sm text-ink-500">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}

export function CardBody({ className, children }) {
  return <div className={cn('px-6 py-5', className)}>{children}</div>
}

export function CardFooter({ className, children }) {
  return (
    <div
      className={cn(
        'flex items-center justify-end gap-2 border-t border-ink-100 bg-ink-50/30 px-6 py-4 rounded-b-2xl',
        className,
      )}
    >
      {children}
    </div>
  )
}
